"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _vehicleCompare = _interopRequireDefault(require("../styles/vehicle-compare.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var selectUpdateEvent = function selectUpdateEvent(params) {
  var event = params.event,
      updateSelected = params.updateSelected,
      vehicleCode = params.vehicleCode,
      index = params.index;
  var selectedCode = event.target.value;
  updateSelected(vehicleCode, selectedCode, index);
};

var replaceThousandsSeperator = function replaceThousandsSeperator(priceString, currentSeperator, updatedSeperator) {
  var thousandsSeperatorRegExp = new RegExp("(\\d)(" + currentSeperator + ")(\\d)", 'g');
  return priceString.replace(thousandsSeperatorRegExp, "$1" + updatedSeperator + "$3");
};

var formatOverrideFunctions = {
  'nb-NO': function nbNO(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  },
  'pt-PT': function ptPT(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  }
};

var overrideFormatting = function overrideFormatting(locale, formattedPrice) {
  if (formatOverrideFunctions[locale] !== undefined) {
    formatOverrideFunctions[locale](formattedPrice);
  }

  return formattedPrice;
};

var localeSwap = {
  'ro-RO': 'es-ES',
  'fr-BE': 'es-ES',
  'es-ES': 'it-IT'
};

var shouldLocaleSwap = function shouldLocaleSwap(locale) {
  return locale in localeSwap ? localeSwap[locale] : locale;
};

var checkIfDecimalsTrue = function checkIfDecimalsTrue() {
  var _false = false,
      returnDecimal = _false.returnDecimal;

  if (returnDecimal === true) {
    return 2; // eslint-disable-line
  }

  return 0;
};

var formatPrice = function formatPrice(options) {
  var _true = true,
      returnZero = _true.returnZero;
  var currency = options.currency,
      locale = options.locale,
      value = options.value,
      zeroMessage = options.zeroMessage; // Testing if any of the props are not avalible and if the value is equal to 0

  if (value === 0) {
    if (typeof zeroMessage === 'string' && zeroMessage.length > 1) {
      return {
        zeroMessage: zeroMessage
      };
    }

    if (returnZero !== true) {
      return ' ';
    }
  }

  if (value === undefined || value === null || !locale || !currency) {
    return ' ';
  }

  var formattedPrice = new Intl.NumberFormat(shouldLocaleSwap(locale), {
    // eslint-disable-line
    style: 'currency',
    currency: currency,
    minimumFractionDigits: checkIfDecimalsTrue(),
    maximumFractionDigits: checkIfDecimalsTrue(),
    currencyDisplay: 'symbol'
  }).format(value);
  return overrideFormatting(locale, formattedPrice);
};

var CompareSelectBoxes = function CompareSelectBoxes(_ref) {
  var models = _ref.models,
      updateSelected = _ref.updateSelected,
      vehicleCode = _ref.vehicleCode,
      index = _ref.index,
      value = _ref.value,
      selectedModelCodes = _ref.selectedModelCodes,
      config = _ref.config;
  return /*#__PURE__*/_react["default"].createElement("select", {
    className: _vehicleCompare["default"].selectTrim,
    value: value,
    onChange: function onChange(event) {
      return selectUpdateEvent({
        event: event,
        updateSelected: updateSelected,
        vehicleCode: vehicleCode,
        index: index
      });
    }
  }, models == null ? void 0 : models.map(function (model) {
    var _model$price2;

    if (selectedModelCodes.includes(model.code)) {
      var _model$price;

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("option", {
        disabled: true,
        key: model.code,
        value: model.code
      }, model.name, model && model.price && model.price.value !== null && '- ', formatPrice({
        value: model == null ? void 0 : (_model$price = model.price) == null ? void 0 : _model$price.value,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      })));
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("option", {
      key: model.code,
      value: model.code
    }, model.name, model && model.price && model.price.value !== null && '- ', formatPrice({
      value: model == null ? void 0 : (_model$price2 = model.price) == null ? void 0 : _model$price2.value,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode')
    })));
  }));
};

var _default = CompareSelectBoxes;
exports["default"] = _default;